<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p27" title="27">
<p class="icon"><span class="grey">[</span> QUICK PREP <span class="grey">]</span></p>
<h2 class="recipetitle" id="frozen_blueberry_breakfast_bars">Frozen Blueberry Breakfast Bars</h2>
<p class="recipetime"><span class="yield_black">10 bars</span> <span class="separater">|</span> Prep Time: 10 Minutes <span class="separater">|</span> Start to Finish: 3 Hours 35 Minutes</p>
<p class="dot">•••</p>
<ul class="ingredient">
<li class="list"><span class="qty1">2½</span> cups oats and honey granola</li>
<li class="list"><span class="qty1">¼</span> cup butter, melted</li>
<li class="list"><span class="qty1">3</span> containers (5.3 oz each) Greek blueberry yogurt</li>
<li class="list"><span class="qty1">¼</span> cup fresh blueberries</li>
<li class="list"><span class="qty1">2</span> tablespoons oats and honey granola, coarsely crushed</li>
</ul>
<p class="recipeprocedure"><span class="stepnum">1</span> Heat oven to 350°F. In large bowl, mix 2½ cups granola and the melted butter. Firmly press in bottom of ungreased 8-inch square pan. Bake 10 minutes. Cool 10 minutes on cooling rack. Freeze about 5 minutes or until cold.</p>
<p class="recipeprocedure"><span class="stepnum">2</span> Spoon yogurt over crust; gently spread to cover. Sprinkle with blueberries and crushed granola. Freeze about 3 hours or until firm.</p>
<p class="recipeprocedure"><span class="stepnum">3</span> Remove from freezer 10 minutes before cutting. Cut into 5 rows by 2 rows. Wrap tightly. Store in freezer up to 2 weeks.</p>
<p class="recipe_info"><span class="nutr_bold">1 Bar:</span> Calories 180; Total Fat 7g (Saturated Fat 3g, Trans Fat 0g); Cholesterol 15mg; Sodium 100mg; Total Carbohydrate 24g (Dietary Fiber 1g); Protein 5g <span class="nutr_bold">Exchanges:</span> 1½ Starch, 1 Fat <span class="nutr_bold">Carbohydrate Choices:</span> 1½</p>
<p class="recipe_note"><span class="tips">Fresh Idea</span> Ice cream for breakfast! Not really, but with these nutritious, frosty bars in your freezer, breakfast is sure to be fun, as well as fast.</p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p027.vue?08bac0d4